// extracted by mini-css-extract-plugin
export default {"name":"RateBlock_name__Oe3U5"};